import { type FC, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useUsersQuery } from "@/partner/entities/users";

interface CreatorOption {
  value: string;
  label: string;
}

interface CreatorsAutocompleteProps {
  label: string;
  value: string[];
  onChange: (creatorIds: string[]) => void;
}

// Тот же паттерн, что ContentsAutocomplete/TagsAutocomplete — список
// UsersList (useUsersQuery) вместо отдельного autocomplete-резолвера.
// Подпись опции — displayName пользователя (email — фолбэк, если displayName
// не заполнен). Чипы уже выбранных id, не попавших в текущую страницу
// результатов, останутся без подписи, пока пользователь не введёт search,
// который их найдёт (см. ContentsAutocomplete.tsx).
export const CreatorsAutocomplete: FC<CreatorsAutocompleteProps> = ({
  label,
  value,
  onChange,
}) => {
  const [search, setSearch] = useState("");

  const { data, loading } = useUsersQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: { search: search || undefined },
      page: 0,
      rowsPerPage: 20,
    },
  });

  const options: CreatorOption[] = (data?.users?.nodes ?? []).map((node) => ({
    value: node.id,
    label: node.displayName || node.email || node.id,
  }));

  return (
    <Autocomplete<CreatorOption, true>
      multiple
      fullWidth
      filterOptions={(opts) => opts}
      loading={loading}
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      value={options.filter((option) => value.includes(option.value))}
      onInputChange={(_event, newInputValue, reason) => {
        setSearch(reason === "reset" ? "" : newInputValue);
      }}
      onChange={(_event, newValue) => {
        onChange(newValue.map((option) => option.value));
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};
